export const useIsPresenting = () => {
  return new URL(location.href).searchParams.has("presentation");
};
